/* ======= All App File Include Here ======= */
// Vuetify Css
// import 'vuetify/dist/vuetify.min.css'
// import 'vuetify/dist/vuetify.css'
import 'vuetify/dist/vuetify.min.css'

// nprogress
import 'nprogress/nprogress.css'

// animate css
import '../assets/animate.css'

// Global Scss File
import '../assets/scss/_style.scss'
